import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { leftPadWithZeros } from 'AppSrc/core/utility-functions/number-functions';
import { saveTabDataToSessionStorage, getTabDataToSessionStorage } from 'AppSrc/core/utility-functions/dash-tab-session-func';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';
import { MYCoordinatorWorkQueueTable } from './my-crq-coordinator-work-queue-table';
import {
  PEER_TAB_ID,
  // CIRCUITCHECK_TAB_ID,
  APPROVAL_TAB_ID,
  INITIAL_COMMS_SENT,
  APPROVED,
  CLOUSER,
} from './coordinator-work-queue-constants';
import {
  FIXED, MOBILE,
} from '../forms/value-dependency-constants';


// Display component for the work queue
const MyCRQCoordinatorWorkQueueDisplayConnect = ({
  handleTabClick,
  selectedTab,
  stats,
  crqList,
  fetching,
  isChangeAnalyst,
  network,
}) => {

  const statusMapping = {
    status: {
      0: 'Draft',
      1: 'Request For Authorization',
      2: 'Request For Change',
      3: 'Planning In Progress',
      4: 'Scheduled For Review',
      5: 'Scheduled For Approval',
      6: 'Scheduled',
      7: 'Implementation In Progress',
      8: 'Pending',
      9: 'Rejected',
      10: 'Completed',
      11: 'Closed',
      12: 'Cancelled',
    },
  };

  useEffect(() => {
    saveTabDataToSessionStorage(selectedTab, 'MyBucketTabSession');
    getTabDataToSessionStorage('MyBucketTabSession');
  }, [selectedTab]);

  const { status } = statusMapping;

  const getClouserTime = (time) => 72 - moment(moment().format()).diff(time, 'hours');

  const getData = () => {
    const time = moment.tz(DEFAULT_TIMEZONE).valueOf();
    if (selectedTab === INITIAL_COMMS_SENT && network === FIXED) {
      const res = crqList.filter((item) => item).map((item) => ({ ...item, status: status[item.status] }));
      stats[selectedTab] = res.length;
      return res;
    }
    if (selectedTab === APPROVED) {
      const res = crqList.filter((item) => moment(item.end_date).valueOf() > time);
      return res;
    }
    if (selectedTab === CLOUSER) {
      return crqList.map((item) => ({
        ...item,
        clouser_timing: getClouserTime(item.end_date),
      }));
    }
    return crqList;
  };

  const tabs = [
    {
      id: PEER_TAB_ID,
      label: 'Pending Peer Review',
    },
    {
      id: APPROVAL_TAB_ID,
      label: 'Pending Approvals',
    },
    {
      id: APPROVED,
      label: 'Fully Approved',
    },
    {
      id: CLOUSER,
      label: 'Pending Closure',
    },
  ];

  const extraTabs = [
    {
      id: INITIAL_COMMS_SENT,
      label: 'Initial Comms Sent',
    },
  ];
  const init = () => (network === MOBILE ? [...tabs] : [...tabs, ...extraTabs]);
  // Circuit check tab added for Change Analyst, however we dont need this for myCRQs.
  // if (isChangeAnalyst) {
  //   tabs.splice(2, 0, {
  //     id: CIRCUITCHECK_TAB_ID,
  //     label: 'Circuit Checks',
  //   });
  // }
  return (
    <div className="coordinator-work-queue">
      <div className="page-content-inner">
        <div className="coordinator-work-queue-tabs">
          {init().map(({ id, label }) => (
            <OptionButton
              className={`tab${selectedTab === id ? ' tab-selected' : ''}`}
              option={id}
              onClick={handleTabClick}
              key={id}
            >
              <span className="tab-statistic-number">{leftPadWithZeros((stats[id] || 0), 2)}</span>
              <span className="tab-statistic-label">{label}</span>
            </OptionButton>
          ))}
        </div>
      </div>
      {
        isChangeAnalyst
          ? ''
          : null
      }
      { fetching ? (
        <div className="coordinator-work-queue-table-loader">
          <LoadingSpinner />
        </div>
      ) : (
        <MYCoordinatorWorkQueueTable
          tab={selectedTab}
          crqList={getData()}
        />
      )}
    </div>
  );
};

MyCRQCoordinatorWorkQueueDisplayConnect.propTypes = {
  handleTabClick: PropTypes.func,
  selectedTab: PropTypes.string,
  stats: PropTypes.objectOf(PropTypes.number),
  crqList: PropTypes.arrayOf(PropTypes.object),
  fetching: PropTypes.bool,
  isChangeAnalyst: PropTypes.bool,
  network: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  isChangeAnalyst: state && state.auth.isChangeAnalyst,
});
const MyCoordinatorWorkQueueDisplay = connect(
  mapStateToProps,
)(MyCRQCoordinatorWorkQueueDisplayConnect);

export { MyCoordinatorWorkQueueDisplay };

